var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"table is-bordered"},[_c('tbody',_vm._l((_vm.imgdata),function(row,row_i){return _c('tr',{key:`TROW_${row_i}`},[_c('td',[_c('show-image',{attrs:{"src":row.clipart.clipart.file,"width":row.clipart.width,"height":row.clipart.height}})],1),_c('td',[_vm._v(_vm._s(row.title))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }